import assetPath from '/app/packages/entity-pages/entity-pages-about-us/src/assets/about-us.svg';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')